import React, { useEffect } from 'react';
import { UpcomingEvents } from './UpcomingEventsLanding';
import { Box, Flex, Text, Heading } from '@spothero/ui';
import { useSelector } from 'react-redux';
import StorageUtils from '@spothero/utils/storage';
import SegmentUtils from 'utils/segment';
import { NotGoingToEvent } from '../not-going-to-event/NotGoingToEvent';
export const VenueEventSEMEdit = () => {
    const title = useSelector((state) => state.destination.data.title);
    const searchString = useSelector((state) => state.searchRequest.search_string);
    const partner = useSelector((state) => state.searchRequest.partner);
    useEffect(() => {
        const userLatLng = StorageUtils.get('sh-user-location', 'session');
        SegmentUtils.track({
            event: 'Event List Display',
            properties: {
                /* eslint-disable camelcase */
                ...(userLatLng && { user_location: userLatLng }),
                ...(searchString && { search_query: searchString }),
                destination: title,
                /* eslint-enable camelcase */
            },
        });
    }, [searchString, title]);
    const applePartnerTitle = partner === 'apple' ? 'Book Parking for ' : '';
    return (<Flex paddingX="4" data-testid="VenueEventSEMEdit" width="100%" flexDirection="column" flexGrow="1">
            <Box>
                <Heading as="h3" paddingBottom="2" paddingTop={2}>
                    {applePartnerTitle}
                    {title}
                    {applePartnerTitle ? '' : ' Parking'}
                </Heading>
                <Text fontSize="sm" fontWeight="medium">
                    Upcoming Events
                </Text>
            </Box>
            <Flex flex="1" overflowY="auto" marginY="2">
                <UpcomingEvents />
            </Flex>
            <Box flex="0 0 auto">
                <NotGoingToEvent />
            </Box>
        </Flex>);
};
